import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=784da800&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('784da800', component.options)
    } else {
      api.reload('784da800', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=784da800&", function () {
      api.rerender('784da800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Error/Index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Error/Index.vue
// module id = SDre
// module chunks = 0